export const environmentBase = {
  production: false,
  adminHostURL: 'https://admin.testgodev.nl',
  helpHostURL: 'https://gonnaorder.com/help/',
  hostURL: 'https://gonnaorder.com/',
  stagingHost: 'testgodev',
  VAPID_PUBLIC_KEY: 'BH-cXEE6u4oWK61uILsQVZx_8DmGIXVXJzorS0bgADLqr5kzw9A6QV6DiHaazrUYxOUWH-BnByRroMYOvxnXpzY',
  myNextEndpointUrl: 'https://nextadmin.azurewebsites.net/api/',
  name: window['env'].name, // environment name
  facebookClientId: window['env'].facebookClientId, // facebook sso client id
  facebookApiVersion: 'v20.0', // facebook sso api version
  envDomain: window['env'].envDomain, // gonna order environment domain
  defaultDeeplinkAppId: 'com.gonnaorder.godev',
  defaultDeeplinkAppAndroidUrl: 'https://play.google.com/store/apps/details?id=com.gonnaorder.godev',
  defaultDeeplinkAppIOSUrl: 'https://apps.apple.com/nl/app/gonnaorder/id1566767814?l=en',
  googleMapAPIKey: window['env'].googleMapAPIKey,
  hubriseLoginUrl: 'https://manager.hubrise.com/oauth2/v1/authorize?redirect_uri={{gonnaorder_uri}}/hubrise-user-login&client_id={{client_id}}&scope=location[orders.write,customer_list.write,catalog.write]&country={{country}}&account_name={{account_name}}',
  hubriseClientId: window['env'].hubriseClientId,
  eventsBackendURL:'https://dev.api.thexo.app', // events backend url
  firebaseConfig: { // firebase configuration
    apiKey: "AIzaSyD9SfnOCskFaUzk2u2zXuGyLAbjy0EVHoQ",
    authDomain: "goadmin-d621f.firebaseapp.com",
    projectId: "goadmin-d621f",
    storageBucket: "goadmin-d621f.appspot.com",
    messagingSenderId: "982274508593",
    appId: "1:982274508593:web:281374a78063f446c39210",
    measurementId: "G-S2BRD6HWWN"
  },
  webSocketTopic: "/topic/events.orders.",
  webSocketEndPoint: 'wss://admin.testgodev.nl/go',
  fcmTopicPrefix: 'develop-fcm-topic-order-',
  templateStoreAlias: '',
  appId: '',
  tenantDomain: '',
}
